import { withInstall } from '@xzx-design/utils'
import _Loading from './src/loading.vue'

export const Loading = withInstall(_Loading)
export default Loading

export * from './src/loading'
export * from './src/types'
